module.exports.base_url = 'https://www.cmsapi.scientexconference.com/';
module.exports.admin_base_url = 'https://www.admin.scientexconference.com/';

// module.exports.base_url = 'http://localhost:8081/';
// module.exports.admin_base_url = 'http://localhost:8181/';
